import type { Order, Tax } from "@jti/magento";
import type { MagentoPrice } from "@jti/magento-types";

import { type FreeTrialPrice } from "../types/FreeTrialCart.types";

export const mapFreeTrialPriceFromOrder = (order?: Partial<Order>): FreeTrialPrice => {
  const item = Array.isArray(order?.items) ? order?.items[0] : null;
  const totalAfterTrial = order?.total_after_trial?.total?.value ?? 0;
  const totalAfterTrialInclTax = order?.total_after_trial?.total_incl_tax?.value ?? 0;
  const grandTotal = order?.prices?.grandTotal;
  const subtotal = order?.total_including_trial?.total_incl_tax?.value ?? 0;
  const deposit = order?.prices?.subtotalIncludingTax?.value ?? 0;
  const discount = item?.price_range?.maximum_price?.discount?.amount_off ?? 0;
  const shipping = order?.total?.total_shipping?.value ?? 0;
  const appliedTaxes = order?.prices?.appliedTaxes;
  const totalNowTax: Tax[] = appliedTaxes ?? [];
  const total = grandTotal?.value ?? 0;

  const afterTrialTax: MagentoPrice | null = order?.total_after_trial?.tax || null;
  const totalAfterTrialTax: Tax[] = [];

  if (afterTrialTax && appliedTaxes?.length) {
    totalAfterTrialTax.push({
      amount: afterTrialTax,
      label: "totalAfterTrialTax",
    });
  }

  return {
    currency: grandTotal?.currency ?? "",
    subtotal,
    deposit,
    shipping,
    total,
    discount,
    totalNowTax,
    totalAfterTrial,
    totalAfterTrialTax,
    totalAfterTrialInclTax,
  };
};
